import React, { forwardRef, useState } from 'react'

import { ArcadeIcon, SensitiveHiddenIcon, SensitiveVisibleIcon } from '@arcade/web/icons/react'

import FormattedInput, { BaseFormattedInputProps } from '../Input/FormattedInput'

export type SsnInputVariant = 'FULL' | 'LAST_FOUR'

export interface SsnInputProps extends BaseFormattedInputProps {
  variant: SsnInputVariant
  showSsnAriaLabel: string
  hideSsnAriaLabel: string
}

const FULL_SSN_TEMPLATE = '###-##-####'
const LAST4_TEMPLATE = '####'
const SsnInput = forwardRef<HTMLInputElement, SsnInputProps>(
  ({ hideSsnAriaLabel, placeholder, showSsnAriaLabel, variant, ...restProps }, ref) => {
    const template = variant === 'LAST_FOUR' ? LAST4_TEMPLATE : FULL_SSN_TEMPLATE
    const [isHidden, setHidden] = useState(true)

    return (
      <FormattedInput
        {...restProps}
        ref={ref}
        template={template}
        placeholder={placeholder || template}
        TrailingIcon={(isHidden ? SensitiveHiddenIcon : SensitiveVisibleIcon) as ArcadeIcon}
        trailingIconClickProps={{
          onClick: () => setHidden(!isHidden),
          ariaLabel: isHidden ? showSsnAriaLabel || '' : hideSsnAriaLabel || '',
        }}
        type={isHidden ? 'password' : 'text'}
      />
    )
  }
)

SsnInput.displayName = 'SsnInput'

export default SsnInput
